// import { navigate } from 'hookrouter'
import React, { FC, useEffect } from 'react'
// import { ListGroup } from 'react-bootstrap'
import { Button } from 'react-bootstrap'
import { ProjectRolesParam } from 'types'
import { useAppContext } from 'state/context'
import { getPermissionsList, updatePermissionsList } from 'state/async_actions'
import { useNewPermissions } from 'hooks/useCompanyManagers'
// import { useProjectsForCompany } from 'hooks/useProjectsForCompany'

export const ProjectPermissionsList: FC<ProjectRolesParam> = ({
  companyId,
  projectId,
  projectUserType
}) => {
  const [, dispatch] = useAppContext();
  
  const permissionsList:any = useNewPermissions(projectUserType) || {};
  useEffect(() => {
    if(companyId && projectUserType)
    getPermissionsList(dispatch,companyId, projectUserType);
  }, [dispatch, companyId, projectUserType]);

  // const projectList = useProjectsForCompany(companyId)
  // const selectedProject:any =  projectList.find((company:any) => company.id === projectId) || {};
  let userRoleType = projectUserType;
  // if (selectedProject.isCompanyManager)
  //   userRoleType = 1;
  // else if (selectedProject.isProjectManager)
  //   userRoleType = 2;
  // else if (selectedProject.isProjectCoordinator)
  //   userRoleType = 5;
  // else if (selectedProject.isSuperForeman)
  //   userRoleType = 3;
  // else if (selectedProject.isSubCordinator)
  //   userRoleType = 4;

  const updatePersisson = (data:boolean)=>{
    updatePermissionsList(dispatch, companyId, permissionsList.id, { permissions: permissionsList.permissions}, permissionsList);
    getPermissionsList(dispatch,companyId, projectUserType);
  }

  return (
    <>
      {((userRoleType !== 3) && (userRoleType !== 4)) && <div className="users">
        <div className="permission-heading">Inviting Other Users</div>
        {(userRoleType === 1) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Add/Invite Company Manager?</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.invite?.invite_company_manager ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.invite.invite_company_manager = !permissionsList?.permissions?.invite?.invite_company_manager; updatePersisson(permissionsList?.permissions?.invite?.invite_company_manager) }}>{permissionsList?.permissions?.invite?.invite_company_manager ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Add/Invite Project Manager?</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.invite?.invite_project_manager ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.invite.invite_project_manager = !permissionsList?.permissions?.invite?.invite_project_manager; updatePersisson(permissionsList?.permissions?.invite?.invite_project_manager) }}>{permissionsList?.permissions?.invite?.invite_project_manager ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Add/invite (Project Coordinator )/ Super/ Foreman?</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.invite?.invite_other_roles ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.invite.invite_other_roles = !permissionsList?.permissions?.invite?.invite_other_roles; updatePersisson(permissionsList?.permissions?.invite?.invite_other_roles) }}>{permissionsList?.permissions?.invite?.invite_other_roles ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        <br />
      </div>
      }
      <div className="documents">
        <div className="permission-heading">Documents</div>
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Sign a Document</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.can_sign ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.can_sign = !permissionsList?.permissions?.document?.can_sign; updatePersisson(permissionsList?.permissions?.document?.can_sign) }}>{permissionsList?.permissions?.document?.can_sign ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Documents that they have signed</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.view_self_signed ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.view_self_signed = !permissionsList?.permissions?.document?.view_self_signed; updatePersisson(permissionsList?.permissions?.document?.view_self_signed) }}>{permissionsList?.permissions?.document?.view_self_signed ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Documents that they have not signed</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.view_signed_by_other ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.view_signed_by_other = !permissionsList?.permissions?.document?.view_signed_by_other; updatePersisson(permissionsList?.permissions?.document?.view_signed_by_other) }}>{permissionsList?.permissions?.document?.view_signed_by_other ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View draft Documents they created</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.view_self_draft ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.view_self_draft = !permissionsList?.permissions?.document?.view_self_draft; updatePersisson(permissionsList?.permissions?.document?.view_self_draft) }}>{permissionsList?.permissions?.document?.view_self_draft ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View draft Documents created by other users</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.view_draft_by_other ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.view_draft_by_other = !permissionsList?.permissions?.document?.view_draft_by_other; updatePersisson(permissionsList?.permissions?.document?.view_draft_by_other) }}>{permissionsList?.permissions?.document?.view_draft_by_other ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Download Documents they created</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.download_self_created ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.download_self_created = !permissionsList?.permissions?.document?.download_self_created; updatePersisson(permissionsList?.permissions?.document?.download_self_created) }}>{permissionsList?.permissions?.document?.download_self_created ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Download Documents others created</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.download_created_by_other ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.download_created_by_other = !permissionsList?.permissions?.document?.download_created_by_other; updatePersisson(permissionsList?.permissions?.document?.download_created_by_other) }}>{permissionsList?.permissions?.document?.download_created_by_other ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Create new Documents</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.can_create ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.can_create = !permissionsList?.permissions?.document?.can_create; updatePersisson(permissionsList?.permissions?.document?.can_create) }}>{permissionsList?.permissions?.document?.can_create ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {/* {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Publish Documents</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.can_publish ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.can_publish = !permissionsList?.permissions?.document?.can_publish; updatePersisson(permissionsList?.permissions?.document?.can_publish) }}>{permissionsList?.permissions?.document?.can_publish ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        } */}
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Documents they published</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.view_self_published ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.view_self_published = !permissionsList?.permissions?.document?.view_self_published; updatePersisson(permissionsList?.permissions?.document?.view_self_published) }}>{permissionsList?.permissions?.document?.view_self_published ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Documents that other users published</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.view_published_by_others ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.view_published_by_others = !permissionsList?.permissions?.document?.view_published_by_others; updatePersisson(permissionsList?.permissions?.document?.view_published_by_others) }}>{permissionsList?.permissions?.document?.view_published_by_others ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        <br />
      </div>
      <div className="companies">
        <div className="permission-heading">Companies</div>
        {((userRoleType === 1)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Create new Companies and manage payments</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.company?.can_create ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.company.can_create = !permissionsList?.permissions?.company?.can_create; updatePersisson(permissionsList?.permissions?.company?.can_create) }}>{permissionsList?.permissions?.company?.can_create ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType == 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Companies that they manage/work for</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.company?.view_assigned ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.company.view_assigned = !permissionsList?.permissions?.company?.view_assigned; updatePersisson(permissionsList?.permissions?.company?.view_assigned) }}>{permissionsList?.permissions?.company?.view_assigned ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Companies that they do not manage/work for</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.company?.view_not_assigned ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.company.view_not_assigned = !permissionsList?.permissions?.company?.view_not_assigned; updatePersisson(permissionsList?.permissions?.company?.view_not_assigned) }}>{permissionsList?.permissions?.company?.view_not_assigned ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        <br />
      </div>
      <div className="projects">
        <div className="permission-heading">Projects</div>
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Create new Projects</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.project?.can_create ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.project.can_create = !permissionsList?.permissions?.project?.can_create; updatePersisson(permissionsList?.permissions?.project?.can_create) }}>{permissionsList?.permissions?.project?.can_create ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Projects that they manage/work for</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.project?.view_assigned ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.project.view_assigned = !permissionsList?.permissions?.project?.view_assigned; updatePersisson(permissionsList?.permissions?.project?.view_assigned) }}>{permissionsList?.permissions?.project?.view_assigned ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Projects that they do not manage/work for</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.project?.view_not_assigned ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.project.view_not_assigned = !permissionsList?.permissions?.project?.view_not_assigned; updatePersisson(permissionsList?.permissions?.project?.view_not_assigned) }}>{permissionsList?.permissions?.project?.view_not_assigned ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        <br />
      </div>
      <div className="template documents">
        <div className="permission-heading">Template Documents</div>
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Sign Template Document</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_sign ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_sign = !permissionsList?.permissions?.template_document?.can_sign; updatePersisson(permissionsList?.permissions?.template_document?.can_sign) }}>{permissionsList?.permissions?.template_document?.can_sign ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Delete template</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_delete ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_delete = !permissionsList?.permissions?.template_document?.can_delete; updatePersisson(permissionsList?.permissions?.template_document?.can_delete) }}>{permissionsList?.permissions?.template_document?.can_delete ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Delete Document</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.can_delete ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.can_delete = !permissionsList?.permissions?.document?.can_delete; updatePersisson(permissionsList?.permissions?.document?.can_delete) }}>{permissionsList?.permissions?.document?.can_delete ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Copy Template from one Project to Another</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.copy_from_one_project_to_another ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.copy_from_one_project_to_another = !permissionsList?.permissions?.template_document?.copy_from_one_project_to_another; updatePersisson(permissionsList?.permissions?.template_document?.copy_from_one_project_to_another) }}>{permissionsList?.permissions?.template_document?.copy_from_one_project_to_another ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {(userRoleType === 1) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Copy Template from one Company to Another</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_copy_one_company_to_another ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_copy_one_company_to_another = !permissionsList?.permissions?.template_document?.can_copy_one_company_to_another; updatePersisson(permissionsList?.permissions?.template_document?.can_copy_one_company_to_another) }}>{permissionsList?.permissions?.template_document?.can_copy_one_company_to_another ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Create Folders within Project</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.create_folder_within_project ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.create_folder_within_project = !permissionsList?.permissions?.template_document?.create_folder_within_project; updatePersisson(permissionsList?.permissions?.template_document?.create_folder_within_project) }}>{permissionsList?.permissions?.template_document?.create_folder_within_project ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Move Templates into Folders</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.move_template_to_folder ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.move_template_to_folder = !permissionsList?.permissions?.template_document?.move_template_to_folder; updatePersisson(permissionsList?.permissions?.template_document?.move_template_to_folder) }}>{permissionsList?.permissions?.template_document?.move_template_to_folder ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Email Documents</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_email ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_email = !permissionsList?.permissions?.template_document?.can_email; updatePersisson(permissionsList?.permissions?.template_document?.can_email) }}>{permissionsList?.permissions?.template_document?.can_email ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {/* {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Email Document they publish</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.email_self_published ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.email_self_published = !permissionsList?.permissions?.document?.email_self_published; updatePersisson(permissionsList?.permissions?.document?.email_self_published) }}>{permissionsList?.permissions?.document?.email_self_published ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        } */}
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Print Documents</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_print ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_print = !permissionsList?.permissions?.template_document?.can_print; updatePersisson(permissionsList?.permissions?.template_document?.can_print) }}>{permissionsList?.permissions?.template_document?.can_print ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 4) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Publish Documents</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_publish ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_publish = !permissionsList?.permissions?.template_document?.can_publish; updatePersisson(permissionsList?.permissions?.template_document?.can_publish) }}>{permissionsList?.permissions?.template_document?.can_publish ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {/* {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Print Document that others publish</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.document?.print_published_by_other ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.document.print_published_by_other = !permissionsList?.permissions?.document?.print_published_by_other; updatePersisson(permissionsList?.permissions?.document?.print_published_by_other) }}>{permissionsList?.permissions?.document?.print_published_by_other ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        } */}
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Create new Template Documents</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_create ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_create = !permissionsList?.permissions?.template_document?.can_create; updatePersisson(permissionsList?.permissions?.template_document?.can_create) }}>{permissionsList?.permissions?.template_document?.can_create ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Edit Template Documents</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_edit ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_edit = !permissionsList?.permissions?.template_document?.can_edit; updatePersisson(permissionsList?.permissions?.template_document?.can_edit) }}>{permissionsList?.permissions?.template_document?.can_edit ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {/* {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>Edit Template Documents that other users created</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_edit ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_edit = !permissionsList?.permissions?.template_document?.can_edit; updatePersisson(permissionsList?.permissions?.template_document?.can_edit) }}>{permissionsList?.permissions?.template_document?.can_edit ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        } */}
        {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 4) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Template Document</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_view ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_view = !permissionsList?.permissions?.template_document?.can_view; updatePersisson(permissionsList?.permissions?.template_document?.can_view) }}>{permissionsList?.permissions?.template_document?.can_view ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        }
        {/* {((userRoleType === 1) || (userRoleType === 2) || (userRoleType === 3) || (userRoleType === 5)) && <div className="row role-list-card">
          <div className="col-11" style={{ paddingTop: '6px' }}>
            <span>View Template Document that others created</span>
          </div>
          <div className="col-1">
            <Button className={permissionsList?.permissions?.template_document?.can_view ? 'disabled-button' : 'permission-add-button'} onClick={() => { permissionsList.permissions.template_document.can_view = !permissionsList?.permissions?.template_document?.can_view; updatePersisson(permissionsList?.permissions?.template_document?.can_view) }}>{permissionsList?.permissions?.template_document?.can_view ? 'Remove' : 'Add'}</Button>
          </div>
        </div>
        } */}
      </div>
    </>
  )
}
